module.exports = __webpack_public_path__ + "static/img/ios-code.f4c4d9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/ios-code.png
// module id = KS13
// module chunks = 1